// No private corpus or Drive IDs in the public JavaScript bundle.
export let ilahiCatalogue={items:[],categories:[]}, devotionalTexts={items:[]}, libraryCatalogue={items:[]}, publicLessons=[], catalogueDisplay={}, libraryDriveLinks={}, footprintSources=[];
export function setPrivateContent(data={}){
 ilahiCatalogue=data.ilahiCatalogue||{items:[],categories:[]};devotionalTexts=data.devotionalTexts||{items:[]};
 libraryCatalogue=data.libraryCatalogue||{items:[]};publicLessons=data.publicLessons||[];
 catalogueDisplay=data.catalogueDisplay||{};libraryDriveLinks=data.libraryDriveLinks||{};footprintSources=data.footprintSources||[];
}
